<template>
  <div id="">
    <div class="">
      <div class="card-body">
        <div class="row d-flex justify-content-space-around align-items-end">
          <h3 class="col-md-9 p-0 col-12 text-dark">
            {{ $t('Borracharia') }} - {{ $t('Servicos') }}
          </h3>
          <div class="col-md-3 p-0 col-12">
            <label>{{ $t('NR Fogo') }}</label>
            <v-select :options="fogos" @input="filtrarNrFogo($event)" :placeholder="$t('NR Fogo')">
            </v-select>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      isSidebarOpen: false,
      showFiltros: false,
    }
  },

  components: {
  },

  computed: {
    fogos() {
      const fogos = this.$store.getters['borracharia/getFiltersTemp']

      if(!fogos){
        this.$store.dispatch('borracharia/getFiltros')

        return []
      }

      return fogos.map(fogo => {
        return {
          ...fogo,
          label: fogo.nr_fogo
        }
      })
    },

    veiculos() {
      const itemsFiltros = this.$store.getters['borracharia/getPlacas']
      // console.log(itemsFiltros)

      if (!itemsFiltros) {
        this.$store.dispatch('borracharia/fetchFromPlacas')
        return []
      }

      return itemsFiltros.map(item => {
        return {
          ...item,
          label: item.nr_placa
        }
      })
    },


    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },
  },
  methods: {
    filtrarNrFogo(event) {
      let filters = { ...event }

      console.log(filters)
      if(event == null) {
        this.$store.commit('borracharia/setFilters', { filters: {}})
        this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
      } else {
        this.$store.commit('borracharia/setFilters', { filters: filters})
        this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
      }

    },

    applyFilters() {
      let filters = { ...this.internalFilters }

      this.$store.commit('os/setFilters', { filters: filters })

      document.getElementById('btnFiltro').click()
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApi')
    },
    resetFilters() {
      const filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: '',
        segmento: ''
      }
      document.getElementById('btnFiltro').click()
      this.$store.commit('os/setFilters', { filters: filters })
    },
    esconderFiltros() {
      this.showFiltros = !this.showFiltros
      this.$scrollTo('#osList')
    }
  },

}
</script>